// import { Component, OnInit } from '@angular/core';
import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
  Input,
  NgModule,
  CUSTOM_ELEMENTS_SCHEMA,
  APP_INITIALIZER,
  DEFAULT_CURRENCY_CODE,
  LOCALE_ID,
  Inject,
} from '@angular/core';
// import { NgModule } from '@angular/core';
// import {
//   NgModule,
//   CUSTOM_ELEMENTS_SCHEMA,
//   APP_INITIALIZER,
//   DEFAULT_CURRENCY_CODE,
//   LOCALE_ID,
// } from '@angular/core';
import { DgGridLibModule } from 'dg-grid-lib';
import { MatLabel } from '@angular/material/form-field';
import { MatTabGroup } from '@angular/material/tabs';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InputType } from 'dg-input-lib';
import { HttpClient, HttpParams } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { Observable, Subscription, of } from 'rxjs';
// import { TranslateService } from '@ngx-translate/core/lib/translate.service';
import { CaseView } from 'src/app/digigov/models/caseview.model';
import { DgActionService } from '../services/dg-action.service';
import { event } from 'jquery';
import { EncryptionService } from 'src/app/digigov/services/encryption.service';
import { NotingsService } from '../../dg-notings/service/notings.service';
// import { ReqObject } from '../../dg-case-notings/dg-case-notings.component';
// import { ReqObject } from '../dg-notings.component';
import { Noting } from 'src/app/digigov/models/noting.model';
// import { NotingsService } from '../../service/notings.service';
export class customData {
  selectedData: CaseView[];
  // isFromCustomAction: boolean;
}
interface ReqObject {
  recId: number;
  appTypId: number;
  startIndex?: number;
  rowsPerPage?: number;
  isPaginReq: string;
  noteTypeArr: string;
  myNoting?: boolean;
  mvmntPk?: number;
  mainFileId?: number;
  tabOpenFlag?: number;
  openFrom?: number;
  rstrctDate?: string;
  parallelFileFlag?: boolean;
}
@Component({
  selector: 'app-part-files',
  templateUrl: './part-files.component.html',
  styleUrls: ['./part-files.component.scss'],
})
export class PartFilesComponent implements OnInit {
  @Input() readOnly;
  gridFooterActionsConditionalFormatting: any;
  mainFileId: any;
  subjectId: any;
  sectionId: any;
  deptId: any;
  caseDesc: any;
  draftVo = [];
  draftsone = [];
  refeVo = [];
  refeone = [];
  corrVo = [];
  corrone = [];
  noteVo = [];
  noteone = [];
  refdocVo = [];
  refdocone = [];
  canAddRow = false;
  isRowSelectable = true;
  showCheckboxForSelection = true;
  allowMultiRowSelection = true;
  notingValue: string;
  // rowsfour: {
  //   notingsno: Noting;
  //   description: string;
  //   username: string;
  //   deptname: string;
  //   notedate: string;
  //   fromPostId: number;
  //   noteCntr: number;
  //   noteIdPk: number;
  // }[];
  rowsfour = [];
  // gridConfig: {
  //   id: string;
  //   wordLimit: number;
  //   showSearch: boolean;
  //   showColoredRowText: boolean;
  //   showLegend: boolean;
  //   pageSize: number;
  //   isRowSelectable: boolean;
  //   allowMultiRowSelection: boolean;
  //   linkColumns: any[];
  //   legends: any[];
  //   columnHeaders: { attributeName: string; columnCaption: string }[];
  //   showColumnsWithWidth: { name: string; width: number }[];
  //   externalPaging: boolean;
  //   gridDataService: {
  //     url: string;
  //     method: string;
  //     input: { startPage: string; mvmntPk: string };
  //   };
  //   activePage: number;
  // };
  onFinalPath($event: any) {
    // throw new Error('Method not implemented.');
  }
  content: any;
  rowstwo: {
    notingsno: number;
    description: any;
    username: any;
    deptname: any;
    notedate: any;
  }[];
  attachId: any;
  getSelectedDraftFromGridthree($event: any) {
    throw new Error('Method not implemented.');
  }
  onClickthree($event: any) {
    throw new Error('Method not implemented.');
  }
  onClicktwo($event: any) {
    throw new Error('Method not implemented.');
  }

  gridConfigone;
  gridConfigtwo;
  gridConfig;
  getSelectedDraftFromGrid($event: any) {
    // throw new Error('Method not implemented.');
  }
  onClick($event: any) {
    // throw new Error('Method not implemented.');
  }

  selectedTabIndex: any;
  constructor(
    private http: HttpClient,
    private actionservice: DgActionService,
    private encryptionService: EncryptionService,
    private dialogRef: MatDialogRef<PartFilesComponent>,
    private notingService: NotingsService,
    @Inject(MAT_DIALOG_DATA) public data: customData // public translate: TranslateService
  ) {}
  panelstate = true;
  subjectDescription: any;
  fileno: any;
  panelOpenState = true;
  @ViewChild('tabs') tabGroup: MatTabGroup;
  @Output() closeTab = new EventEmitter();
  rows = [];
  columns = [];
  rowsone = [];
  rowsthree = [];
  columnsone = [
    {
      columnId: 'noteCntr',
      width: 100,
      displayable: true,
      sortable: false,
      type: 1,
      isLink: false,
      align: 'left',
      searchable: false,
      columnName: 'Notings No',
    },
    {
      columnId: 'description',
      width: 100,
      displayable: true,
      sortable: false,
      type: 1,
      isLink: false,
      align: 'left',
      searchable: false,
      columnName: 'Notings',
    },
    {
      columnId: 'username',
      width: 100,
      displayable: true,
      sortable: false,
      type: 1,
      isLink: false,
      align: 'left',
      searchable: false,
      columnName: 'Employee Name',
    },
    // {
    //   columnId: 'deptname',
    //   width: 100,
    //   displayable: true,
    //   sortable: false,
    //   type: 1,
    //   isLink: false,
    //   align: 'left',
    //   searchable: false,
    //   columnName: 'Department Name',
    // },
    {
      columnId: 'notedate',
      width: 100,
      displayable: true,
      sortable: false,
      type: 1,
      isLink: false,
      align: 'left',
      searchable: false,
      columnName: 'Notings Date',
    },
    // {
    //   columnId: 'noteIdPk',
    //   width: 100,
    //   displayable: true,
    //   sortable: false,
    //   type: 1,
    //   isLink: true,
    //   align: 'left',
    //   searchable: false,
    //   columnName: 'NoteIdpk',
    // },

    // {
    //   columnId: 'fromPostId',
    //   width: 100,
    //   displayable: true,
    //   sortable: false,
    //   type: 1,
    //   isLink: true,
    //   align: 'left',
    //   searchable: false,
    //   columnName: 'FromPostId',
    // },
  ];

  // gridConfigthree = {
  //   id: 'docNo',
  //   // wordLimit: 100,
  //   // showSearch: true,
  //   // showColoredRowText: true,
  //   // showLegend: false,
  //   // pageSize: 5,
  //   // isRowSelectable: true,
  //   allowMultiRowSelection: true,

  //   linkColumns: [
  //     // { attributeNameToShowLink: 'corrNo' },
  //     // {
  //     //   attributeNameToShowLink: 'attachmentCntDtl',
  //     // },
  //   ],
  //   legends: [],
  //   columnHeaders: [
  //     // { attributeName: 'attachmentCntDtl', columnCaption: 'No of Attachment' },
  //     // {
  //     //   attributeName: 'corrAddedBy',
  //     //   columnCaption: 'Correspondence Added By',
  //     // },
  //     // {
  //     //   attributeName: 'statusName',
  //     //   columnCaption: 'Correspondance Status',
  //     // },
  //   ],
  //   showColumnsWithWidth: [
  //     // { name: 'corrNo', width: 190 },
  //     // { name: 'attachmentCntDtl', width: 150 },
  //     // { name: 'corrAddedBy', width: 200 },
  //     // { name: 'corrAddedDt', width: 210 },
  //     // { name: 'statusName', width: 180 },
  //   ],
  //   externalPaging: true,
  //   gridDataService: {
  //     url: '/case-mgmnt/ref-docs-in-case',
  //     method: 'POST',
  //     input: {
  //       startPage: '1',
  //       // mvmntPk: null,Number(this.caseData?.caseDetails?.docId)
  //       // caseId: this.data?.selectedData[0].docId,
  //     },
  //   },
  // activePage: 1,
  // };

  ngOnInit(): void {
    console.log(this.readOnly);
    // http://localhost:8023/digigov/case-mgmnt/case-details?fileId=274134&dbSchema=-1&mvmntPk=null&applicationTypeId=1&openFrom=1
    // this.http.get(
    //   '/case-mgmnt/case-details?fileId=274134&dbSchema=-1&mvmntPk=null&applicationTypeId=1&openFrom=1'
    // );

    // let paramsone = new HttpParams();
    // paramsone = paramsone.append('recId', this.data.selectedData[0].docId);
    // paramsone = paramsone.append('appTypId', '1');
    // paramsone = paramsone.append('isPaginReq', 'true');
    // paramsone = paramsone.append('noteTypeArr', '193');
    // paramsone = paramsone.append('tabOpenFlag', '1');
    // paramsone = paramsone.append('startIndex', '1');
    // paramsone = paramsone.append('rowsPerPage', '5');
    // // paramsone = paramsone.append('openFrom', '4');
    // this.http
    //   .get('case-mgmnt/notings', { params: paramsone })
    //   .subscribe((res) => {
    //     console.log(res);data.rows
    //   });

    // case-mgmnt/notings?recId=488354&appTypId=1&isPaginReq=true&noteTypeArr=193&tabOpenFlag=1&startIndex=1&rowsPerPage=5&openFrom=3

    let postdata = {
      fileId: Number(this.data.selectedData[0].docId),

      mvmntPk: Number(this.data?.selectedData[0].jobMvmntPk),
    };
    this.actionservice.getRefDocs(postdata).subscribe((res) => {
      let content: any = res;

      this.columns = [
        {
          columnId: 'docName',
          width: 100,
          displayable: true,
          sortable: false,
          type: 1,
          isLink: false,
          align: 'left',
          searchable: false,
          columnName: 'Document Title',
        },

        {
          columnId: 'crtOn',
          width: 100,
          displayable: true,
          sortable: false,
          type: 0,
          align: 'left',
          searchable: false,
          columnName: 'Date of Document',
        },
        {
          columnId: 'docType',
          width: 100,
          displayable: true,
          sortable: false,
          type: 0,
          align: 'left',
          searchable: false,
          columnName: 'Document Type',
        },
      ];

      this.rows = content.data.rows;
    });

    // this.notingService.getNotings(requestObj).subscribe((res) => {
    //       let tempNotingsList = res.data;
    //       if (tempNotingsList == null) {
    //         return;
    //       }
    //       tempNotingsList.forEach((t) => {
    //         t.isChecked = event.checked;
    //         t.isSelected = event.checked;
    //         if (t.noteContent) {
    //           const notingValue = this.encryptionService.decrypt(
    //             t.noteContent,
    //             this.encryptionService.param3
    //           );
    //           t.noteContentDecrypted = notingValue;
    //         }
    //         if (t.isChecked) {
    let requestObj: ReqObject;
    requestObj = {
      recId: this.data.selectedData[0].docId,
      appTypId: 1,
      startIndex: 1,
      rowsPerPage: 5,
      isPaginReq: 'true',
      noteTypeArr: '192,193,195',
    };
    let postdataone = {
      fileId: Number(this.data.selectedData[0].docId),

      mvmntPk: Number(this.data?.selectedData[0].jobMvmntPk),
    };
    this.actionservice
      .getNotings(postdataone)
      .subscribe((out: { data: Noting[] }) => {
        const templist: Noting[] = out.data;
        if (templist) {
          let i = 0;
          this.rowsone = [];
          templist?.forEach((temp) => {
            const notingValue = this.encryptionService.decrypt(
              temp.noteContent,
              this.encryptionService.param3
            );

            this.notingValue = notingValue;
            console.log(notingValue);
            this.rowsfour = [
              {
                notingsno: i,
                description: notingValue,
                username: temp.noteCrtEmpName,
                deptname: temp.deptName,
                notedate: temp.noteCrtDt,
                fromPostId: temp.fromPostId,
                noteCntr: temp.noteCntr,
                noteIdPk: temp.noteIdPk,
              },
            ];
            i = i + 1;
            this.rowsone.push(this.rowsfour[0]);
            // temp['attachmentNumber'] = temp?.attachId;
            // temp['noteContentDecrypted'] = notingValue;
          });
        }
        // this.allNotings = templist;
        // this.totalNotingCount = this.allNotings[0]?.paginationVO?.totalRecords;
      });

    //         this.columnsone.forEach((c) => {
    //           if (c?.columnId === 'description') {
    //             // c.displayable = this.surveyService.surveyConfig?.showStatus;
    //             // c.template = this.statusTemplate;
    //              this.rowsone[0].description = this.statusTemplate;
    //           }});
    // this.rowsone[0].description = this.statusTemplate;
    // this.actionservice
    //   .getNotings(Number(this.data.selectedData[0].docId))
    //   .subscribe((res) => {
    //     console.log(res);
    //     let content: any = res;
    //     let tempNotingsList = res.data;
    //     // tempNotingsList = res;
    //     if (tempNotingsList == null) {
    //       return;
    //     }
    //     tempNotingsList.forEach((t) => {
    //       if (t.noteContent) {
    //         const notingValue = this.encryptionService.decrypt(
    //           t.noteContent,
    //           this.encryptionService.param3
    //         );
    //         t.noteContentDecrypted = notingValue;
    //         console.log(notingValue);
    //         console.log(t.noteContentDecrypted);
    //       }
    //       //              this.rowsone = [
    //       //                {
    //       //                  notingsno: i,
    //       //                  description: notingValue,
    //       //                  username: content.data[i].dsgnShrtName,
    //       //                  deptname: content.data[i].deptName,
    //       //                  notedate: content.data[i].noteCrtDt,
    //       //                  fromPostId: content.data[i].fromPostId,
    //       //                  noteCntr: content.data[i].noteCntr,
    //       //                  noteIdPk: content.data[i].noteIdPk,
    //       //                },
    //       //              ];
    //       // this.rowsthree.push()
    //     });
    //     for (let i = 0; i <= content.data.length; i++) {
    //       console.log(content.data.length);
    //       // this.attachId = content.data[i].attachId;
    //       // console.log(
    //       //   this.encryptionService.encrypt(
    //       //     content.data[i].noteContent,
    //       //     this.encryptionService.param3
    //       //   )

    //       // );
    //       const notingValue = this.encryptionService.decrypt(
    //         content.data[i].noteContent,
    //         this.encryptionService.param3
    //       );

    //       console.log(notingValue);

    //       this.rowsone = [
    //         {
    //           notingsno: i,
    //           description: notingValue,
    //           username: content.data[i].dsgnShrtName,
    //           deptname: content.data[i].deptName,
    //           notedate: content.data[i].noteCrtDt,
    //           fromPostId: content.data[i].fromPostId,
    //           noteCntr: content.data[i].noteCntr,
    //           noteIdPk: content.data[i].noteIdPk,
    //         },
    //       ];
    //       //   // this.rowsone.push(this.rowsthree[0]);
    //       //   // {
    //       //   //   description: 'content.data[0].noteContent',
    //       //   //   docName: '2',
    //       //   // },
    //     }
    //   });
    this.actionservice
      .getCaseDetails(this.data.selectedData[0].docId)
      .subscribe((response) => {
        console.log('Result', response);
        const restemp: any = response;
        // this.fullCaseDetails.emit(restemp.data);
        this.content = restemp.data;
        this.fileno = this.content.fileNo;
        this.subjectDescription = this.content.subjectName;
        this.mainFileId = this.content.fileId;
        this.subjectId = this.content.subjectId;
        this.sectionId = this.content.sectionId;
        this.deptId = this.content.deptId;
        this.caseDesc = this.content.fileDesc;
        // console.log(this.content.fileNo);
      });
    // this.httpdata.subjectNamedata.fileNo
    //  (response) => {
    //     console.log('Result', response);
    //     const restemp: any = response;
    //     this.fullCaseDetails.emit(restemp.data);
    //     this.content = restemp.data;
    //   .get('/case-mgmnt/case-details', { params: params })
    //   .subscribe((res) => {
    //     console.log(res);
    //     // this.subjectDescription = res.data.subjectName;data.fileNo
    //   });
    // this.columnsone=[]
    this.gridConfig = {
      id: 'corrNo',
      wordLimit: 100,
      showSearch: true,
      showColoredRowText: true,
      showLegend: false,
      pageSize: 5,
      isRowSelectable: true,
      allowMultiRowSelection: true,

      linkColumns: [
        // { attributeNameToShowLink: 'corrNo' },
        // {
        //   attributeNameToShowLink: 'attachmentCntDtl',
        // },
      ],
      legends: [],

      columnHeaders: [
        {
          attributeName: 'attachmentCntDtl',
          columnCaption: 'No of Attachment',
        },
        {
          attributeName: 'corrAddedBy',
          columnCaption: 'Correspondence Added By',
        },
        {
          attributeName: 'statusName',
          columnCaption: 'Correspondance Status',
        },
      ],
      showColumnsWithWidth: [
        { name: 'corrNo', width: 190 },
        { name: 'attachmentCntDtl', width: 150 },
        { name: 'corrAddedBy', width: 200 },
        { name: 'corrAddedDt', width: 210 },
        { name: 'statusName', width: 180 },
      ],
      externalPaging: true,
      gridDataService: {
        url: '/correspondence-mgmnt/correspondence-dtls?type=0&caseId=',
        method: 'POST',
        input: {
          startPage: '1',
          mvmntPk: this.data?.selectedData[0].jobMvmntPk,
        },
      },
      activePage: 1,
    };
    this.gridConfig.gridDataService.url =
      this.gridConfig.gridDataService.url + this.data?.selectedData[0].docId;
    this.gridConfig = { ...this.gridConfig };

    // this.gridConfigthree.gridDataService.url =
    //   this.gridConfigthree.gridDataService.url +
    //   this.data?.selectedData[0].docId;
    // this.gridConfigthree = { ...this.gridConfigthree };
    this.gridConfigone = {
      id: 'draftNo', //to uniquely identify rows for selecting values
      // showSearch: false,
      showColoredRowText: true,
      // showLegend: false,
      pageSize: 5,
      isRowSelectable: true,
      allowMultiRowSelection: true,
      linkColumns: [
        // { attributeNameToShowLink: 'draftNo' },
        // { attributeNameToShowLink: 'draftHistoryLink' },
        // { attributeNameToShowLink: 'draftTitle' },
      ],
      wordLimit: 100,
      showSearch: true,
      // showColoredRowText: false,
      showLegend: false,
      legends: [],
      columnHeaders: [
        { attributeName: 'draftTitle', columnCaption: 'Draft Title' },
        { attributeName: 'preparedByName', columnCaption: 'Initiated By' },
        // { attributeName: 'lastActionBy', columnCaption: 'Last Action By' },
        { attributeName: 'draftStatusName', columnCaption: 'Draft Status' },
        { attributeName: 'approvalDate', columnCaption: 'Approval Date' },
        { attributeName: 'approvedByName', columnCaption: 'Approved By' },
        // { attributeName: 'draftId', columnCaption: 'Draft ID' },
        // { createdDatedraftId attributeName: 'draftHistoryLink', columnCaption: 'Show History' },
      ],
      showColumnsWithWidth: [
        /* { name: 'dateOfDraft', width: 80 },
        { name: 'draftTitle', width: 100 },
        { name: 'draftDetailsLink', width: 60 },
        { name: 'draftHistoryLink', width: 70 },
        { name: 'draftStatusName', width: 90 },
        { name: 'preparedByName', width: 100 }, */
        { name: 'draftTitle', width: 150 },
        { name: 'preparedByName', width: 100 },
        // { name: 'lastActionBy', width: 150 },
        { name: 'draftStatusName', width: 100 },
        { name: 'approvalDate', width: 120 },
        { name: 'approvedByName', width: 100 },
        // { name: 'draftId', width: 100 },
        // { name: 'draftHistoryLink', width: 100 },
      ],
      externalPaging: true,
      gridDataService: {
        url: '/case-mgmnt/drafts',
        method: 'POST',
        input: {
          startPage: '1',
          ServiceID: 2388,
          refId: this.data?.selectedData[0].docId?.toString(),
          appId: this.data?.selectedData[0].appTypeId,
          draftMpgId: 10,
          jobId: this.data?.selectedData[0]?.jobId?.toString(),

          // draftMpgId: 10,
          // jobId: '',
          mvmntPk: this.data?.selectedData[0].jobMvmntPk,
          mainFileId1: null,
          draftStatus: '970',
          openFrom: '2',
          // this.caseDetails?.openFrom == 5
          //   ? 'Intimations'
          //   : this.caseDetails?.openFrom,
          // rstrctDate: this.caseDetails?.rstrctDate,
        },
      },
      activePage: 1,

      // processResponse(response: any, flag?: boolean) {
      //   console.log(response);
      // },
    };
    this.gridConfigtwo = {
      // id: 'draftNo', //to uniquely identify rows for selecting values
      // // showSearch: false,
      // showColoredRowText: true,
      // // showLegend: false,
      // pageSize: 5,
      // isRowSelectable: true,
      // allowMultiRowSelection: true,
      // linkColumns: [
      //   // { attributeNameToShowLink: 'draftNo' },
      //   // { attributeNameToShowLink: 'draftHistoryLink' },
      //   // { attributeNameToShowLink: 'draftTitle' },
      // ],
      // wordLimit: 100,
      // showSearch: true,
      // // showColoredRowText: false,
      // showLegend: false,
      // legends: [],
      id: 'caseId',
      wordLimit: 100,
      showSearch: true,
      showColoredRowText: true,
      showLegend: false,
      pageSize: 5,
      isRowSelectable: true,
      allowMultiRowSelection: true,
      linkColumns: [
        // { attributeNameToShowLink: 'caseNo' }
      ],
      legends: [],
      //   // {
      //   //   attributeName: 'approvedFlag',
      //   //   color: 'orange',
      //   //   legendName: 'Approved',
      //   // },
      //   // {
      //   //   attributeName: 'previouslySeenFlag',
      //   //   color: 'violet',
      //   //   legendName: 'Previously Seen',
      //   // },
      //   // { attributeName: 'readFlag', color: 'red', legendName: 'New' },
      // ],

      columnHeaders: [
        { attributeName: 'caseNo', columnCaption: 'File No' },
        {
          attributeName: 'caseDesc',
          columnCaption: 'Description',
        },

        { attributeName: 'sectionName', columnCaption: 'Subject' },
        {
          attributeName: 'organizationName',
          columnCaption: 'Branch',
        },
      ], // gridAttributeColumnHeaderMpgVOLst
      showColumnsWithWidth: [
        { name: 'caseNo', width: 100 },
        { name: 'caseDesc', width: 100 },
        { name: 'subjectName', width: 100 },
        { name: 'organizationName', width: 100 },
        // { name: 'sectionName', width: 100 },
        // { name: 'stageName', width: 100 },
        // { name: 'fileCreatedDate', width: 200 },
      ],
      externalPaging: true,
      gridDataService: {
        url: `/case-mgmnt/precedent-cases`,
        method: 'POST',
        input: {
          ServiceID: 1154,
          caseId: this.data?.selectedData[0].docId,
          startPage: '1',
          mvmntPk: this.data?.selectedData[0].jobMvmntPk,
          mainFileId: null,
          openFrom: 2,
          // rstrctDate: this.case?.rstrctDate,

          // ServiceID: this.case.isFromOutboxCases ? 2499 : 1154,
          // caseId:this.data?.selectedData[0].docId,
          // startPage: '1',
          // mvmntPk: this.case?.isFromOutboxCases ? this.case?.jobMvmntPk : null,
          // mainFileId: this.case?.mainFileId ? this.case?.mainFileId : null,
          // openFrom: this.case.openFrom == 5 ? 'Intimations' : this.case?.openFrom,
          // rstrctDate: this.case?.rstrctDate,
        },
      },

      activePage: 1,
    };
    //  prepareRows(data: any, flag?: boolean): void;
    this.gridConfigone = { ...this.gridConfigone };
    this.gridConfigtwo = { ...this.gridConfigtwo };
    // this.gridConfigone.gridDataService.input.refId = this.data.selectedData[0].docId.toString();
    // (this.gridConfigone.gridDataService.input.appId = this.data?.selectedData[0].appTypeId),
    //   (this.gridConfigone.gridDataService.input.jobId = this.data?.selectedData[0]?.jobId?.toString()),
    //   //  refId: this.data?.selectedData[0].docId?.toString(),
    //   //         appId: this.data?.selectedData[0].appTypeId,
    //   //         draftMpgId: 10,
    //   //         jobId: this.data?.selectedData[0]?.jobId?.toString(),

    //   (this.gridConfigone = { ...this.gridConfigone });
    //  setTimeout(() => {
    //    this.showGrid = true;
    //  }, 500);
    this.ondraftload();
  }

  ondraftload() {}

  onConditionalFormattingActionPerformed(data: any) {
    // // throw new Error('Method not implemented.');
    // this.noteVo = [];
    // this.noteone = [];
    // for (let i = 0; i < data.length; i++) {
    //   this.noteVo = [
    //     {
    //       noteIdPk: 130851402,
    //       noteCntr: 1,
    //       fromPostId: 100003506,
    //     },
    //   ];
    // }
  }
  onConditionalFormattingActionPerformedOne(data: any) {}
  getData(data: any) {
    // throw new Error('Method not implemented.');correspondancecoorid they want

    this.corrVo = [];
    this.corrone = [];
    for (let i = 0; i < data.length; i++) {
      this.corrVo = [
        {
          corrID: data[i].corrID,
        },
      ];
      this.corrone.push(this.corrVo[0]);
    }
  }
  getDataone(data: any) {
    this.draftVo = [];
    this.draftsone = [];
    for (let i = 0; i < data.length; i++) {
      // this.draftVo.push(data[i].draftId);
      this.draftVo = [
        {
          draftId: data[i].draftId,
        },
      ];
      this.draftsone.push(this.draftVo[0]);
    }

    // throw newdrafts Error('Method not implemented.');draftsdraftid want two rowsselectionmenas two values
  }
  getSelectedDraftFromGridtwo(data: any) {
    // precedentcase fileid want
    // throw new Error('Method not implemented.');referencefiles[0].caseNo

    this.refeVo = [];
    this.refeone = [];
    for (let i = 0; i < data.length; i++) {
      // this.draftVo.push(data[i].draftId);
      this.refeVo = [
        {
          fileId: data[i].caseId,
        },
      ];
      this.refeone.push(this.refeVo[0]);
    }
  }
  onRowSelection(data: any) {
    // throw new Error('Method not implemented.');
    // // throw new Error('Method not implemented.');
    this.noteVo = [];
    this.noteone = [];
    for (let i = 0; i < data.length; i++) {
      this.noteVo = [
        {
          noteIdPk: data[i].noteIdPk,
          noteCntr: data[i].noteCntr,
          fromPostId: data[i].fromPostId,
          noteContent: data[i].description,
        },
      ];
      this.noteone.push(this.noteVo[0]);
    }
  }
  onRowSelectionone(data: any) {
    // throw new Error('Method not implemented.');
    this.refdocVo = [];
    this.refdocone = [];
    for (let i = 0; i < data.length; i++) {
      this.refdocone = [
        {
          refDocId: data[i].refDocId,
        },
      ];
    }
  }
  onClickone($event: any) {
    // throw new Error('Method not implemented.');
  }
  onclose() {}
  oncreate() {
    let postData = {
      mainFileId: this.mainFileId,
      subjectId: this.subjectId,

      sectionId: this.sectionId,
      deptId: this.deptId,
      caseDesc: this.caseDesc,
      notingsVOArr: this.noteone,
      corrVOArr: this.corrone,
      precedentCaseVOArr: this.refeone,
      refDocsVOArr: this.refdocone,
      // draftVo: [{ draftId: this.draftVo }],
      draftVOArr: this.draftsone,
    };
    this.actionservice.create(postData).subscribe((res) => {
      console.log(res);
      // this.onclose();
      this.closeTab.emit(true);
      this.dialogRef.close();
      // window.close()
    });
    this.closeTab.emit(true);
    //localhost:8023/digigov/case-mgmnt/create-part-file
    // http: POST;
    //   "notingsVo":[{
    //     "noteIdPk":130851402,
    //     "noteCntr":1,
    //     "fromPostId":100003506
    // }],
    // "corrVo":[{"corrId":1}],
    // "precedentCaseVo":[{"fileId":489784}

    // ],
    // "refDocs":[{"refDocId":1}],
    // "draftVo":[{"draftId":130030892}]
  }
}
